import { trackComoLlegar, buildMapsUrl } from '../tracking';

/**
 * CTA "Cómo llegar" — pastilla con gradiente de marca HOP.
 * Abre Google Maps direcciones en nueva pestaña y dispara el tracking.
 *
 * @param {object} punto
 * @param {'lista'|'popup'} source
 * @param {'geolocalizacion'|'direccion'} searchMethod
 * @param {string} [className] - clases extra para ajustar layout
 */
const ComoLlegarCta = ({ punto, source, searchMethod = 'direccion', className = '' }) => {
  const handleClick = (e) => {
    trackComoLlegar(punto, source, searchMethod);
  };

  return (
    <a
      href={buildMapsUrl(punto)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className={`button-gradient relative inline-flex items-center justify-center gap-6 px-14 py-8 rounded-full focus-visible:rounded-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-dark text-white text-11 sm:text-12 font-semibold uppercase tracking-wide hover:opacity-90 transition-opacity ${className}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        fill="none"
        viewBox="0 0 24 24"
        className="relative z-3"
      >
        <path
          fill="currentColor"
          d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
        />
      </svg>
      <span className="relative z-3">Cómo llegar</span>
    </a>
  );
};

export default ComoLlegarCta;